import React, { useState, useEffect } from "react";
import { emailPattern, TYPE_SUCCESS, INTERVAL, TYPE_FAIL, passwordMatchPattern, TYPE_INFO } from "assets/constants/Constants";
import ShowToast from 'components/ShowToast';
import md5 from 'md5';
import { EYE_ICON, EYE_SLASH_ICON } from 'assets/constants/Icons';
// import AuthContext from 'context/AuthProvider';
import { forgotPasswordCall, resetPasswordByOtpCall, findUserNameCall } from "lib/axiosUtils";
import PersonalizeModal from "components/PersonalizeModal";
import vector from "../../assets/images/Vector.svg";

const ForgotPassword = (props) => {
    // const context = useContext(AuthConssssstext);
    const newUserEmailId = props?.match?.params?.emailId;
    const [emailId, setEmailId] = useState(newUserEmailId ? newUserEmailId : "");
    const [otp, setOtp] = useState("");
    const [showResetPasswordScreen, setShowResetPasswordScreen] = useState(newUserEmailId ? true : false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState({});
    const [showPersonalize, setShowPersonalize] = useState(false);

    const emailIdChangeHandler = (event) => {
        setEmailId(event.target.value);
    }

    const changeOTPhandler = (event) => {
        setOtp(event.target.value);
    }

    const changeConfirmPasswordhandler = (event) => {
        setConfirmPassword(event.target.value);
    }

    const changeNewPasswordhandler = (event) => {
        setNewPassword(event.target.value);
    }

    const confirmPasswordViewHandler = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const passwordViewHandler = () => {
        setShowPassword(!showPassword)
    }

    const isFormValid = () => {
        let isValid = true;
        let error = {};
        if (showResetPasswordScreen) {
            if (!otp) {
                isValid = false;
                error.otp = "Please enter OTP";
            }
            if (!newPassword) {
                isValid = false;
                error.newPassword = "Please enter new password";
            }
            if (!confirmPassword) {
                isValid = false;
                error.confirmPassword = "Please enter confirm password";
            }
            if (newPassword && confirmPassword) {
                if (newPassword !== confirmPassword) {
                    isValid = false;
                    error.confirmPassword = "Confirm password and password do not match";
                }
            }
            if (newPassword) {
                if (!passwordMatchPattern.test(newPassword)) {
                    isValid = false;
                    error.newPassword = "Please enter valid new password";
                    ShowToast('Password must be minimum eight characters including one uppercase letter,\n one special character and alphanumeric characters', TYPE_INFO, INTERVAL, props, "");
                }
            }
        }
        else {
            if (emailId) {
                if (!emailPattern.test(emailId)) {
                    isValid = false;
                    error.emailId = "Please enter valid email address.";
                }
            }
            if (!emailId) {
                isValid = false;
                error.emailId = "Please enter email id";
            }
        }
        setError(error);
        return isValid;
    }

    useEffect(() => {
        // This check only applies to the new-user "set your password" flow,
        // where emailId is pre-filled from the route param. It must not run
        // while an existing user is typing their email into the forgot
        // password field, or it will redirect them to /login-page before
        // they can request/enter an OTP.
        if (!newUserEmailId) {
            return;
        }
        const init = async () => {
            if (emailId !== "") {
                if (localStorage.getItem("userData")) {
                    window.location.href = "/home-page";
                } else {
                    const findUserByUsernameResponse = await findUserNameCall({}, {}, emailId);
                    if (findUserByUsernameResponse?.statusCode === 200) {
                        if (findUserByUsernameResponse?.data?.result[0]?.password) {
                            window.location.href = "/login-page";
                        }
                    }
                }
            }
        };
        init();
    }, [emailId, newUserEmailId]);

    const recoverPasswordHandler = async (event) => {
        event.preventDefault();
        if (isFormValid()) {
            const requestData = {
                userEmailId: emailId,
            };
            ShowToast("Please wait while we are sending OTP", TYPE_SUCCESS, INTERVAL, props, "");
            try {
                const userResponse = await forgotPasswordCall({}, requestData);
                if (userResponse && userResponse.statusCode === 200) {
                    if (
                        userResponse.data &&
                        userResponse.data.result &&
                        Object.entries(userResponse.data.result).length === 0
                    ) {
                        ShowToast("User associated with this email id is not found !", TYPE_FAIL, INTERVAL, props, "");
                    } else {
                        ShowToast("OTP Sent successfully !", TYPE_SUCCESS, INTERVAL, props, "");
                        setShowResetPasswordScreen(true);
                    }
                }
            } catch (error) {
                console.log("Error occurred while sending otp", error);
            }
        }
    };

    const handleRedirectToLogin = () => {
        if (props.history) {
            props.history.push("/login-page");
        } else {
            window.location.href = "/login-page";
        }
    };

    const resetPasswordHandler = async (event) => {
        event.preventDefault();
        try {
            if (isFormValid()) {
                const resetPasswordParams = {
                    userEmailId: emailId,
                    userOtp: otp,
                    userPassword: md5(newPassword),
                };

                const resetResult = await resetPasswordByOtpCall({}, resetPasswordParams);

                if (resetResult && resetResult.data.result && Object.entries(resetResult.data.result).length === 0) {
                    ShowToast(`Error occurred! ${resetResult.data.message}`, TYPE_SUCCESS, INTERVAL, props, "");
                } else {
                    if (newUserEmailId) {
                        // New user setting their password for the first time -> collect preferences
                        ShowToast("Password reset successfully! Please configure your preferences.", TYPE_SUCCESS, INTERVAL, null, "");
                        setShowPersonalize(true);
                    } else {
                        // Existing user recovering a forgotten password -> skip personalization
                        ShowToast("Password reset successfully!", TYPE_SUCCESS, INTERVAL, props, "");
                        handleRedirectToLogin();
                    }
                }
            }
        } catch (error) {
            console.log("Error occurred while reset password", error);
        }
    };

    // When personalize is active, render it as a full standalone page (has its own signup-page bg)
    if (showPersonalize) {
        return (
            <PersonalizeModal
                isOpen={true}
                userEmail={emailId}
                onClose={handleRedirectToLogin}
                onSubmit={(data) => {
                    console.log("Personalization submitted on password reset:", data);
                    handleRedirectToLogin();
                }}
            />
        );
    }

    return (
        <section className="signup-page">
            <div className="signup-card signup-card--personalize">
                <div className="signup-panel-right signup-panel-right--personalize" style={{ position: 'relative' }}>
                    <div className="personalize-form-wrapper">
                        <h3 className="personalize-form__title">
                            {showResetPasswordScreen ? "Reset Password" : "Forgot Password"}
                        </h3>
                        <p className="personalize-form__subtitle">
                            {showResetPasswordScreen ? "Create your new password below" : "Enter your email to recover your password"}
                        </p>

                        <form className="personalize-form" onSubmit={(e) => e.preventDefault()} noValidate>
                            {!showResetPasswordScreen ? (
                                <div className="form-field">
                                    <label className="form-field__label">Email ID</label>
                                    <input
                                        type="email"
                                        name="emailId"
                                        value={emailId}
                                        placeholder="Enter Your Email ID"
                                        className="form-field__input"
                                        onChange={emailIdChangeHandler}
                                    />
                                    {error.emailId && <span className="form-field__error">{error.emailId}</span>}
                                </div>
                            ) : (
                                <>
                                    <div className="form-field">
                                        <label className="form-field__label">OTP <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="otp"
                                            value={otp}
                                            placeholder="Please enter OTP"
                                            className="form-field__input"
                                            onChange={changeOTPhandler}
                                        />
                                        {error.otp && <span className="form-field__error">{error.otp}</span>}
                                    </div>

                                    <div className="form-field">
                                        <label className="form-field__label">New Password <span className="text-danger">*</span></label>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="newPassword"
                                                value={newPassword}
                                                placeholder="Please enter new password"
                                                className="form-field__input"
                                                style={{ paddingRight: '40px' }}
                                                onChange={changeNewPasswordhandler}
                                            />
                                            <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                                                <i title={showPassword ? "Hide Password" : "Show Password"} className={showPassword ? EYE_SLASH_ICON : EYE_ICON} onClick={passwordViewHandler} style={{ color: '#999' }}></i>
                                            </div>
                                        </div>
                                        {error.newPassword && <span className="form-field__error">{error.newPassword}</span>}
                                    </div>

                                    <div className="form-field">
                                        <label className="form-field__label">Confirm Password <span className="text-danger">*</span></label>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                name="confirmPassword"
                                                value={confirmPassword}
                                                placeholder="Please enter confirm password"
                                                className="form-field__input"
                                                style={{ paddingRight: '40px' }}
                                                onChange={changeConfirmPasswordhandler}
                                            />
                                            <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                                                <i className={showConfirmPassword ? EYE_SLASH_ICON : EYE_ICON} onClick={confirmPasswordViewHandler} style={{ color: '#999' }}></i>
                                            </div>
                                        </div>
                                        {error.confirmPassword && <span className="form-field__error">{error.confirmPassword}</span>}
                                    </div>
                                </>
                            )}

                            <div className="personalize-form__actions">
                                {showResetPasswordScreen ? (
                                    <button onClick={resetPasswordHandler} className="personalize-form__submit">
                                        Reset My Password
                                        <img src={vector} className="cta-button__icon" alt="" />
                                    </button>
                                ) : (
                                    <button onClick={recoverPasswordHandler} className="personalize-form__submit">
                                        Recover My Password
                                        <img src={vector} className="cta-button__icon" alt="" />
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ForgotPassword;